module.exports = __webpack_public_path__ + "img/looks_3.688884de.svg";